export const SECTION_IDS = {
    HOME: 'home',
    SYSTEM: 'system',
    FUNCTIONS: 'functions',
    SERVICE: 'service',
    ABOUT_US: 'about-us',
    FOOTER: 'footer',
    DEMO: 'demo',
    SYSTEM_FEATURES: 'system-features',
} as const;

export const SECTION_PATHS = {
    HOME: `/#${SECTION_IDS.HOME}`,
    SYSTEM: `/#${SECTION_IDS.SYSTEM}`,
    FUNCTIONS: `/#${SECTION_IDS.FUNCTIONS}`,
    SERVICE: `/#${SECTION_IDS.SERVICE}`,
    ABOUT_US: `/#${SECTION_IDS.ABOUT_US}`,
    FOOTER: `/#${SECTION_IDS.FOOTER}`,
    DEMO: `/#${SECTION_IDS.DEMO}`,
    SYSTEM_FEATURES: `/#${SECTION_IDS.SYSTEM_FEATURES}`,
} as const;
